import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateWorkspace, type UpdateWorkspacePayload, type Workspace } from '../lib/api'
import { workspacesQueryOptions } from './useWorkspaces'

export function useUpdateWorkspace(workspaceId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: UpdateWorkspacePayload) => updateWorkspace(workspaceId, payload),
    onSuccess: (result) => {
      if (!result.success) return

      const queryKey = workspacesQueryOptions().queryKey
      queryClient.setQueryData(queryKey, (current) => {
        if (!current?.success) return current
        return {
          success: true as const,
          data: current.data.map((workspace: Workspace) =>
            workspace.id === workspaceId ? result.data : workspace,
          ),
        }
      })
      queryClient.invalidateQueries({ queryKey })
    },
  })
}
